import Typography from 'typography'

const typography = new Typography({
  overrideStyles: () => ({
    body: {
      minHeight: '100%',
      backgroundColor: '#F5F4F1'
    },
  }),
})

export default typography



// WEBPACK FOOTER //
// ./src/utils/typography.js